export const MENU_AREA = {
    sideBar: 'sidebar',
    navBar: 'navBar',
    slideIn: 'slideIn',
} as const;
